define("shared/components/shared/social/facebook-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--modalBg">
    <div class="o--modal--close" {{action @closeFacebook}}></div>
    <div class="o--modalWrapper">
      <div class="o--modalVer">
        <div class="o--modalCard">
          <header class="o--modalHeader">
            <p class="o--modalHeader__title">
              {{t "account.controllers.groups.facebook.add_profile"}}
            </p>
            <p class="u--m__b__lg u--text--md">
              {{t "account.controllers.groups.facebook.add_profile_text"}}
            </p>
          </header>
          <div class="o--modalBody has--scroll">
            <Shared::Social::FacebookPicker @selectPage={{this.selectPage}} @selectedPageId={{this.selectedPageId}} />
          </div>
          <footer class="o--modalFooter">
            <div class="o--btnBar">
              <Shared::Ui::Button
                @class="u--float--left"
                @onClick={{@closeFacebook}}
                @text={{t "shared_words.cancel"}}
                @variant="outline"
              />
              <Shared::Ui::Button
                @class="u--float--right"
                @isDisabled={{this.buttonIsDisabled}}
                @onClick={{perform this.addPage}}
                @text={{t "account.controllers.social_profiles.new.add_profile"}}
                @variant="primary"
              />
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
  */
  {
    "id": "DQKOd0kC",
    "block": "[[[10,0],[14,0,\"o--modalBg\"],[12],[1,\"\\n  \"],[11,0],[24,0,\"o--modal--close\"],[4,[38,0],[[30,0],[30,1]],null],[12],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--modalWrapper\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--modalVer\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--modalCard\"],[12],[1,\"\\n        \"],[10,\"header\"],[14,0,\"o--modalHeader\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile\"],null]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[10,2],[14,0,\"u--m__b__lg u--text--md\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"account.controllers.groups.facebook.add_profile_text\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--modalBody has--scroll\"],[12],[1,\"\\n          \"],[8,[39,2],null,[[\"@selectPage\",\"@selectedPageId\"],[[30,0,[\"selectPage\"]],[30,0,[\"selectedPageId\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"footer\"],[14,0,\"o--modalFooter\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n            \"],[8,[39,3],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--left\",[30,1],[28,[37,1],[\"shared_words.cancel\"],null],\"outline\"]],null],[1,\"\\n            \"],[8,[39,3],null,[[\"@class\",\"@isDisabled\",\"@onClick\",\"@text\",\"@variant\"],[\"u--float--right\",[30,0,[\"buttonIsDisabled\"]],[28,[37,4],[[30,0,[\"addPage\"]]],null],[28,[37,1],[\"account.controllers.social_profiles.new.add_profile\"],null],\"primary\"]],null],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@closeFacebook\"],false,[\"action\",\"t\",\"shared/social/facebook-picker\",\"shared/ui/button\",\"perform\"]]",
    "moduleName": "shared/components/shared/social/facebook-modal.hbs",
    "isStrictMode": false
  });
  let FacebookModalComponent = _exports.default = (_dec = (0, _service.inject)('social/connect-profiles'), (_class = class FacebookModalComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "connectProfiles", _descriptor4, this);
      _initializerDefineProperty(this, "selectedPage", _descriptor5, this);
      _defineProperty(this, "addPage", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (!this.selectedPage) {
            return;
          }
          try {
            const scopes = this.connectProfiles.authResponse?.grantedScopes;
            yield this.args.addProfile(this.selectedPage.id, this.selectedPage.access_token, scopes ? scopes.split(',') : undefined);
            this.args.closeFacebook();
          } catch (error) {
            this.alerts.warning(this.intl.t('alerts.account.controllers.groups.facebook.add_error'));
            this.errors.log(error, {
              page: JSON.stringify(this.selectedPage)
            });
          }
        }
      }), null, "addPage", "drop"));
    }
    get buttonIsDisabled() {
      return !this.selectedPage || this.addPage.isRunning;
    }
    get selectedPageId() {
      return this.selectedPage?.id;
    }
    selectPage(page, event) {
      event.preventDefault();
      if (this.selectedPage?.id === page.id) {
        this.selectedPage = undefined;
      } else {
        this.selectedPage = page;
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "connectProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedPage", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "selectPage", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "selectPage"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FacebookModalComponent);
});